module.exports = __webpack_public_path__ + "static/media/xueshan_web.bf214b35.webp";